import * as React from 'react';
import { useSelector } from 'react-redux';

import { ServicesV3Container } from './ServicesV3Container';
import { ServicesV4Container } from './ServicesV4Container';
import { selectIsRedesign } from '../../selectors/isRedesign';

export const ServicesContainer: React.FC = () => {
  const isRedesign = useSelector(selectIsRedesign);

  if (isRedesign) {
    return <ServicesV4Container />;
  }

  return <ServicesV3Container />;
};

ServicesContainer.displayName = 'ServicesContainer';
